/* ==========================================================================
   PW — Product page behaviour
   --------------------------------------------------------------------------
   Owns the buy-box UI (gallery, variant picker, quantity) but deliberately
   REUSES the conrise theme's cart plumbing for the actual add-to-cart, so the
   cart drawer, item count and upsell flows keep working exactly as before.

   application.js is not wrapped in an IIFE, so these are true globals:
       openCartDrawer()  reloadCart(cb)  showLoadingIndicator()
       hideLoadingIndicator()  getShopifyApiRoot()
   Each is feature-detected — if the theme ever stops exposing them we fall
   back to a plain /cart redirect rather than silently failing to add.
   ========================================================================== */
(function () {
  'use strict';

  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function $1(s, r) { return (r || document).querySelector(s); }

  function apiRoot() {
    return (typeof getShopifyApiRoot === 'function') ? getShopifyApiRoot() : '/';
  }
  function loadingOn()  { if (typeof showLoadingIndicator === 'function') showLoadingIndicator(); }
  function loadingOff() { if (typeof hideLoadingIndicator === 'function') hideLoadingIndicator(); }

  function afterAdd() {
    if (typeof reloadCart === 'function') {
      reloadCart(function () {
        loadingOff();
        if (typeof openCartDrawer === 'function') openCartDrawer();
        else window.location.href = '/cart';
      });
    } else {
      loadingOff();
      window.location.href = '/cart';
    }
  }

  /* ------------------------------------------------------------ money fmt */
  function money(cents, root) {
    if (root && root.dataset.moneyFormat) {
      /* Mirror the shop's own format string, e.g. "{{amount_with_comma_separator}} €" */
      var v = (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return root.dataset.moneyFormat.replace(/\{\{\s*[a-z_]+\s*\}\}/, v);
    }
    return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  /* ------------------------------------------------------------- buy box */
  function initBuybox(root) {
    $$('[data-pw-buybox]', root).forEach(function (box) {
      if (box.dataset.pwInit) return;
      box.dataset.pwInit = '1';

      var variants;
      try {
        variants = JSON.parse($1('[data-pw-variants]', box).textContent);
      } catch (e) {
        return; /* no variant data — leave the native form alone */
      }

      var idInput   = $1('[data-pw-variant-id]', box);
      var priceEl   = $1('[data-pw-price]', box);
      var compareEl = $1('[data-pw-compare]', box);
      var saveEl    = $1('[data-pw-save]', box);
      var addBtn    = $1('[data-pw-add]', box);
      var addLabel  = addBtn ? $1('[data-pw-add-label]', addBtn) : null;
      var form      = $1('form[data-pw-form]', box);
      var soldOut   = box.dataset.soldOutLabel || 'Ausverkauft';
      var addLabelText = box.dataset.addLabel || 'In den Warenkorb';

      /* ---- option state -------------------------------------------------- */
      function selectedOptions() {
        var opts = [];
        $$('[data-pw-option-group]', box).forEach(function (g) {
          var checked = $1('input[type="radio"]:checked', g);
          opts[parseInt(g.dataset.pwOptionGroup, 10)] = checked ? checked.value : null;
        });
        return opts;
      }

      function findVariant(opts) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i], ok = true;
          for (var n = 0; n < opts.length; n++) {
            if (opts[n] == null) continue;
            if (v.options[n] !== opts[n]) { ok = false; break; }
          }
          if (ok) return v;
        }
        return null;
      }

      /* Grey out option values that cannot combine with the current choice. */
      function refreshAvailability(current) {
        $$('[data-pw-option-group]', box).forEach(function (g) {
          var idx = parseInt(g.dataset.pwOptionGroup, 10);
          $$('input[type="radio"]', g).forEach(function (input) {
            var probe = current.slice();
            probe[idx] = input.value;
            var match = variants.filter(function (v) {
              for (var n = 0; n < probe.length; n++) {
                if (probe[n] == null) continue;
                if (v.options[n] !== probe[n]) return false;
              }
              return true;
            });
            var any = match.length > 0;
            var avail = match.some(function (v) { return v.available; });
            var label = input.closest('[data-pw-option]');
            if (label) {
              label.toggleAttribute('data-pw-unavailable', any && !avail);
              label.toggleAttribute('data-pw-nonexistent', !any);
            }
            input.disabled = !any;
          });
        });
      }

      function update() {
        var opts = selectedOptions();
        var v = findVariant(opts);
        refreshAvailability(opts);

        if (!v) {
          if (addBtn) { addBtn.disabled = true; }
          if (addLabel) addLabel.textContent = soldOut;
          return;
        }

        if (idInput) idInput.value = v.id;

        if (priceEl) priceEl.textContent = money(v.price, box);
        /* Honour the PAngV gate set by Liquid — see pw-pdp-buybox.liquid. */
        var allowCompare = box.dataset.allowCompare !== 'false';
        if (compareEl) {
          if (allowCompare && v.compare_at_price && v.compare_at_price > v.price) {
            compareEl.textContent = money(v.compare_at_price, box);
            compareEl.hidden = false;
            if (saveEl) {
              saveEl.textContent = (box.dataset.saveLabel || 'Spare') + ' ' + money(v.compare_at_price - v.price, box);
              saveEl.hidden = false;
            }
          } else {
            compareEl.hidden = true;
            if (saveEl) saveEl.hidden = true;
          }
        }

        if (addBtn) {
          addBtn.disabled = !v.available;
          if (addLabel) addLabel.textContent = v.available ? addLabelText : soldOut;
        }

        /* Swap the gallery to match the variant.
           Override galleries match on an option VALUE (e.g. "Obsidian");
           product media matches on featured_media_id. */
        var target = null;
        for (var oi = 0; oi < opts.length && !target; oi++) {
          if (!opts[oi]) continue;
          target = $1('[data-pw-option-value="' + (window.CSS && CSS.escape ? CSS.escape(opts[oi]) : opts[oi]) + '"]', box);
        }
        if (!target && v.featured_media_id) {
          target = $1('[data-pw-media-id="' + v.featured_media_id + '"]', box);
        }
        if (target) goToSlide(box, parseInt(target.dataset.pwIndex, 10));

        /* Keep the URL honest so refresh/share preserves the choice. */
        if (window.history && window.history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u);
        }
      }

      $$('[data-pw-option-group] input[type="radio"]', box).forEach(function (input) {
        input.addEventListener('change', update);
      });

      /* ---- quantity ------------------------------------------------------ */
      var qtyInput = $1('[data-pw-qty-input]', box);
      $$('[data-pw-qty]', box).forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!qtyInput) return;
          var step = parseInt(btn.dataset.pwQty, 10) || 1;
          var next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + step);
          qtyInput.value = next;
        });
      });

      /* ---- add to cart ---------------------------------------------------- */
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (addBtn && addBtn.disabled) return;

          loadingOn();
          var fd = new FormData(form);

          fetch(apiRoot() + 'cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: fd
          })
            .then(function (r) {
              return r.json().then(function (body) {
                if (!r.ok) throw body;
                return body;
              });
            })
            .then(function () { afterAdd(); })
            .catch(function (err) {
              loadingOff();
              var msg = (err && (err.description || err.message)) || 'Der Artikel konnte nicht hinzugefügt werden.';
              var box_ = $1('[data-pw-error]', form);
              if (box_) { box_.textContent = msg; box_.hidden = false; }
              else window.alert(msg);
            });
        });
      }

      initGallery(box);
      update();
    });
  }

  /* ------------------------------------------------------------- gallery */
  function goToSlide(box, i) {
    var track = $1('[data-pw-gallery-track]', box);
    if (!track) return;
    var slides = $$('[data-pw-slide]', track);
    if (!slides.length) return;
    i = Math.max(0, Math.min(slides.length - 1, i));
    box.dataset.pwSlide = i;
    track.style.transform = 'translate3d(' + (-i * 100) + '%,0,0)';
    $$('[data-pw-thumb]', box).forEach(function (t, n) {
      t.toggleAttribute('data-pw-active', n === i);
      t.setAttribute('aria-selected', n === i ? 'true' : 'false');
    });
    slides.forEach(function (s, n) { s.setAttribute('aria-hidden', n === i ? 'false' : 'true'); });
  }

  function initGallery(box) {
    var track = $1('[data-pw-gallery-track]', box);
    if (!track || track.dataset.pwInit) return;
    track.dataset.pwInit = '1';

    $$('[data-pw-thumb]', box).forEach(function (t, n) {
      t.addEventListener('click', function () { goToSlide(box, n); });
    });
    $$('[data-pw-gallery-nav]', box).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cur = parseInt(box.dataset.pwSlide || 0, 10);
        goToSlide(box, cur + (parseInt(btn.dataset.pwGalleryNav, 10) || 1));
      });
    });

    /* Touch swipe */
    var x0 = null;
    track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) {
        goToSlide(box, parseInt(box.dataset.pwSlide || 0, 10) + (dx < 0 ? 1 : -1));
      }
      x0 = null;
    }, { passive: true });

    goToSlide(box, 0);
  }

  /* ---------------------------------------------------------------- boot */
  function init(root) { initBuybox(root || document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  window.PWPdp = { init: init };
})();
